import classNames from 'classnames';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { OG_URL } from '../../../const';
import ogImage from '../../../resources/images/og-image.png';
import { setPageCssVariables } from '../../../utils/helper';
import UserMenu from '../../pages/UserMenu';
import Header from './Header';
import styles from './styles.module.scss';

const Layout = (props) => {
    const url = OG_URL;
    const { pageClassName = '', children = null, innerContainerClassName = '', isCatalogLayout = null, cssTypeVariable = '' } = props;
    useEffect(() => {
        setPageCssVariables(!!cssTypeVariable && cssTypeVariable);
    }, [cssTypeVariable]);
    return (
        <>
            <Helmet key={1}>
                <title>The World’s First AI Spiritual Guides</title>
                <meta name="title" content="The World's First AI Spiritual Guides" />
                <meta name="description" content="Veda AI by Astrology.com - The World’s First AI Spiritual Guides!" />

                <meta name="og:type" property="og:type" content="website" />
                <meta name="og:url" property="og:url" content={url} />
                <meta name="og:title" property="og:title" content="The World's First AI Spiritual Guides" />
                <meta
                    name="og:description"
                    property="og:description"
                    content="Veda AI by Astrology.com - The World’s First AI Spiritual Guides!"
                />
                <meta name="og:image" property="og:image" content={ogImage} />

                <meta name="twitter:card" property="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" property="twitter:url" content={url} />
                <meta name="twitter:title" property="twitter:title" content="The World's First AI Spiritual Guides" />
                <meta
                    name="twitter:description"
                    property="twitter:description"
                    content="Veda AI by Astrology.com - The World’s First AI Spiritual Guides!"
                />
                <meta name="twitter:image" property="twitter:image" content={ogImage} />
            </Helmet>
            <div className={classNames(pageClassName, styles.wrapper, { [styles.wrapperLanding]: isCatalogLayout })}>
                <Header isCatalogPage={isCatalogLayout} />
                <div className={classNames('container relative ', innerContainerClassName)}>
                    <UserMenu />
                    {!!children && children}
                </div>
            </div>
        </>
    );
};

export default Layout;
